import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * HO-HU-36: clave del paso de la guia de primeros pasos con el que se llego a
 * esta pantalla (`?onboarding=owners`), o null si el usuario entro por su
 * cuenta.
 *
 * Es lo que usan los modulos de destino para mostrar el banner del paso y, en
 * el caso de Propietarios, para abrir directamente el modal de importacion que
 * corresponde.
 */
const useOnboardingStepParam = () => {
  const { search } = useLocation();

  return useMemo(
    () => new URLSearchParams(search).get("onboarding"),
    [search]
  );
};

export default useOnboardingStepParam;
